import React, { useState, } from "react";

// Importing bootstrap components
import { Col, Card, Form, Button, Spinner } from "react-bootstrap";

// Importing formik & yup
import { Formik } from "formik";
import * as Yup from "yup";

import { useDispatch } from "react-redux";

const initialValues = {
  id: null,
  doc: "",
};

const GeneralAccessManagement = React.memo(
  ({
    isAllowedToRead,
    isAllowedToCreate,
    isAllowedToUpdate,
    isAllowedToDelete,
    HolidayViewManagement,
  }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const [formikValues, setFormikValues] = useState(initialValues);

    const handleCheckboxChange = (event, row) => {
      if (event.target.checked) {
        setSelectedRow(row);
      } else {
        setSelectedRow(null);
        setFormikValues(initialValues);
      }
    };

    const handleEdit = () => {
      setFormikValues(selectedRow);
    };

    const addEDocManage = async (holidayData) => {
      try {
      } catch (err) {
        // Error toast is automatically shown by baseQuery
      }
    };

    const updateEDocManage = async (dataToUpdate) => {
      try {
      } catch (err) {
        // Error toast is automatically shown by baseQuery
      }
    };

    const deleteEDocManage = async () => {
      try {
      } catch (err) {
        // Error toast is automatically shown by baseQuery
      }

      if (selectedRow.id) {
        // Reset formik data
        setFormikValues(initialValues);

        // Reset row data
        setSelectedRow(null);
      }
    };

    const handleSubmit = async (values, { resetForm }) => {
      try {
        if (values.id) {
          updateEDocManage(values);

          // Reset formikValues to initial values after successful creation
          setFormikValues(initialValues);
        } else {
          addEDocManage(values);
        }

        if (selectedRow?.id) {
          setSelectedRow(null);
        }

        resetForm();
      } catch (err) {
        // Error toast is automatically shown by baseQuery
      }
    };

    const validationSchema = Yup.object().shape({
      doc: Yup.string().required("Doc is required"),
    });

    return (
      <section className="section dashboard">
        {(isAllowedToCreate || isAllowedToUpdate) && (
          <Card>
            <Card.Body>
              <Formik
                enableReinitialize={true}
                initialValues={formikValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, handleChange, handleSubmit, touched, errors, isSubmitting }) => (
                  <Form noValidate onSubmit={handleSubmit} className="row mt-3">
                    <Col md={5} className="mb-3 mb-md-0">
                      <Form.Group controlId="name">
                        <Form.Control
                          type="file"
                          name="name"
                          placeholder="Enter holiday name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={touched.name && !!errors.name}
                          disabled={isSubmitting}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Button variant="primary" className="w-100" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              role="status"
                              className="me-2"
                              style={{ width: "18px", height: "18px" }}
                            />
                            {formikValues.id ? "Updating..." : "Adding..."}
                          </>
                        ) : (
                          formikValues.id ? "Save" : "Add"
                        )}
                      </Button>
                    </Col>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        )}
        {isAllowedToRead && (
          <HolidayViewManagement
            isAllowedToUpdate={isAllowedToUpdate}
            isAllowedToDelete={isAllowedToDelete}
            handleCheckboxChange={handleCheckboxChange}
            handleEdit={handleEdit}
            deleteEDocManage={deleteEDocManage}
            selectedRow={selectedRow}
          />
        )}
      </section>
    );
  }
);

export default GeneralAccessManagement;
